import React from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { createStyleSheet, useStyleSheet, Divider, Focusable, Text, useThemeContext } from '@gopeerproject/ui-kit';
import { useMemo } from 'react';
const weekdays = moment.weekdays().slice(1, 6);
export const Days = ({ data }) => {
    const styles = useStyleSheet(getStyles);
    const { color } = useThemeContext();
    const colorsForGroup = useMemo(() => {
        const result = {};
        const colors = [
            color.warning.ghostHover,
            color.parent.ghostHover,
            color.primary.ghostHover,
            color.success.ghostHover,
            color.negative.ghostHover
        ];
        Object.values(data).forEach((day) => {
            day.forEach((interval) => {
                if (!result[interval.group]) {
                    const numOfEachColor = colors.map((c) => Object.values(result).filter((r) => r === c).length);
                    const possibleColors = colors.filter((_, i) => numOfEachColor[i] === Math.min(...numOfEachColor));
                    result[interval.group] =
                        possibleColors[Math.floor(Math.random() * possibleColors.length)];
                }
            });
        });
        return result;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    return (React.createElement(View, { style: styles.container },
        React.createElement(Divider, { type: 'horizontal', style: [styles.divider, { bottom: '0%' }] }),
        React.createElement(Divider, { type: 'horizontal', style: [styles.divider, { bottom: '25%' }] }),
        React.createElement(Divider, { type: 'horizontal', style: [styles.divider, { bottom: '50%' }] }),
        React.createElement(Divider, { type: 'horizontal', style: [styles.divider, { bottom: '75%' }] }),
        React.createElement(Divider, { type: 'horizontal', style: [styles.divider, { bottom: '100%' }] }),
        weekdays.map((day, index) => (React.createElement(View, { key: day, style: [styles.day, index !== 0 ? styles.dayWithMargin : {}] },
            React.createElement(View, { style: styles.hours }, data[day].map((interval) => (React.createElement(Focusable, { key: interval.top, style: [
                    styles.interval,
                    {
                        top: `${interval.top}%`,
                        height: `${interval.height}%`,
                        backgroundColor: colorsForGroup[interval.group]
                    }
                ] }, ({ hovered }) => {
                const prefix = moment().format('YYYY-MM-DD ');
                return (React.createElement(View, { style: {
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Text, { type: 'body', size: 'sm', weight: 'semibold', style: {
                            overflow: 'hidden',
                            textAlign: 'center'
                        } }, interval.customer),
                    hovered && (React.createElement(View, { style: [styles.tooltip] },
                        React.createElement(Text, { type: 'headline', size: 'md' }, interval.group),
                        React.createElement(Text, { type: 'headline', size: 'md' },
                            moment(prefix + interval.from).format('h:mma'),
                            "-",
                            moment(prefix + interval.to).format('h:mma'))))));
            })))))))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        paddingLeft: size.G,
        marginLeft: size.A,
        flexDirection: 'row',
        flexGrow: 1
        // height: 363
    },
    day: {
        alignItems: 'center',
        flexDirection: 'column',
        // width: size.M,
        flex: 1,
        height: '100%',
        // @ts-expect-error typedef
        zIndex: 'unset'
    },
    dayWithMargin: { marginLeft: size.C },
    hours: {
        // backgroundColor: color.invert2.p4,
        flex: 1,
        width: '100%',
        // @ts-expect-error typedef
        zIndex: 'unset'
    },
    interval: {
        backgroundColor: color.primary.solid,
        position: 'absolute',
        width: '100%',
        borderRadius: size.E,
        // @ts-expect-error typedef
        zIndex: 'unset'
    },
    divider: {
        position: 'absolute',
        right: 0,
        left: 0,
        // @ts-expect-error typedef
        zIndex: 'unset'
    },
    tooltip: {
        zIndex: 99,
        backgroundColor: color.bg.v3,
        borderRadius: size.C,
        padding: size.D,
        position: 'absolute',
        width: 160,
        left: `calc(50% - 80px)`,
        flexDirection: 'column',
        justifyContent: 'center',
        bottom: 'calc(100% + 8px)',
        boxShadow: '0px 8px 42px rgba(28, 29, 40, 0.1)'
    },
    tooltip__label: {
        color: color.invert2.p42
    }
}));
//# sourceMappingURL=Days.js.map